import React from 'react'
import { LoadingTextMask } from '../loading-masks'
import { css } from '@emotion/css'

const loadingCellCss = css`
  padding: 0 8px;
  width: 100%;
`

const itemLoadingMaskCss = css`
  padding-bottom: 5px;
`

interface LoadingListCellRendererProps {
  readonly min?: number
  readonly max?: number
}

export class LoadingListCellRenderer extends React.Component<LoadingListCellRendererProps> {
  private numberOfLoadingMasks: number

  constructor(props) {
    super(props)

    const { min = 1, max = 3 } = props

    this.numberOfLoadingMasks =
      Math.floor(Math.random() * (max + 1 - min)) + min
  }

  public render() {
    const masks: JSX.Element[] = []
    for (let i = 0; i < this.numberOfLoadingMasks; i++) {
      masks.push(
        <div
          key={i}
          className={
            i < this.numberOfLoadingMasks - 1 ? itemLoadingMaskCss : ''
          }
        >
          <LoadingTextMask min={5} max={8} />
        </div>
      )
    }
    return <div className={loadingCellCss}>{masks}</div>
  }
}
